import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Plus } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { staffRoleCreateSchema, type StaffRoleCreate } from '../../../../../packages/contracts/src/index.js';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader } from '../../components/ui/card';
import { FieldError, Input, Label } from '../../components/ui/field';
import { api } from '../../shared/api';

export function RoleCreatePage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const form = useForm<StaffRoleCreate>({ resolver: zodResolver(staffRoleCreateSchema), defaultValues: { role: '' } });
  const createRole = useMutation({
    mutationFn: (values: StaffRoleCreate) => api.staffRoles.create(values.role),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['staff-roles'] });
      await queryClient.invalidateQueries({ queryKey: ['staff-users'] });
      navigate('/admin/users');
    },
  });

  return (
    <div className="max-w-lg space-y-5">
      <div>
        <h1 className="text-2xl font-semibold text-slate-950">Nuevo rol</h1>
        <p className="mt-1 text-sm text-slate-500">Crea un rol para asignarlo a usuarios del equipo.</p>
      </div>
      <Card>
        <CardHeader><h2 className="text-sm font-semibold">Rol</h2></CardHeader>
        <CardContent>
          <form className="grid gap-3" onSubmit={form.handleSubmit((values) => createRole.mutate(values))}>
            <div className="grid gap-1.5">
              <Label htmlFor="role">Nombre del rol</Label>
              <Input id="role" placeholder="Ej. Groomer" {...form.register('role')} />
              <FieldError message={form.formState.errors.role?.message} />
            </div>
            {createRole.isError ? <p className="text-sm text-rose-600">{createRole.error.message}</p> : null}
            <Button type="submit" disabled={createRole.isPending}>
              <Plus className="h-4 w-4" aria-hidden="true" />
              Crear rol
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
